export var LEVELS = [
    25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100, 150, 200,
    250, 300, 400, 500,
];
export var DEFAULT_POSITION = LEVELS.indexOf(50);
export var MAX_POSITION = LEVELS.length - 1;
export var MIN_POSITION = 0;
export function getZoomPercentage(zoomPosition) {
    return LEVELS[zoomPosition];
}
export function getPositionForPercentage(zoomPercentage) {
    return LEVELS.indexOf(zoomPercentage);
}
